<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  computed: {
    totalPrice() {
      // if (this.form.isAllUnpaid) {
      //   return 0
      // }
      let valueCharge = null

      if (this.form && this.form.charges) {
        let arr = this.form.charges.filter((i) => i.isValueCharge)
        valueCharge = arr.length == 0 ? null : arr[0].jpySubTotal
      }

      return valueCharge || this.form.branchValue
    },
    totalInsurancePrice() {
      if (this.form && this.form.charges) {
        let arr = this.form.charges.filter((i) => i.isInsuranceCharge)
        return arr.length == 0 ? null : arr[0].jpySubTotal
      }
      return null
    },
    formReadOnly() {
      return this.form.source != 'B1000'
    },
    formValid() {
      return this.formReadOnly || this.valid
    },
  },
  methods: {
    copyAs() {
      localStorage.setItem('sourceB1000Id', this.form.id)
      this.form = {
        ...this.form,
        id: null,
        charges: [],
        summaryCharges: [],
        packages: [],
        totalGW: 0,
        source: 'B1000',
      }
      this.$router.push({
        name: 'B1001New',
        params: { shipment: this.form },
      })
    },
    load() {
      this.$http
        .get(`shipping-advices/${this.$route.query.id}?view=B1001`)
        .then((res) => {
          this.form = {
            ...this.form,
            ...res.data,
            charges: res.data.charges.sort((a, b) =>
              a.chargeItemCode.localeCompare(b.chargeItemCode)
            ),
          }
          this.loadValid = true
        })
        .catch((err) => {
          this.loadValid = false
          // this.$catch(err)
        })
    },

    save() {
      this.$http
        .put(`/shipping-advices/${this.$route.query.id}`, this.form)
        .then(() => {
          this.$router.push({
            path: '/B1000',
          })
        })
        .catch((err) => this.$catch(err))
    },
    chargeGeneration() {
      this.$http
        .put(`/shipping-advices/${this.form.id}?view=B1001`, this.form)
        .then(() => {
          return this.$http.put(
            `/shipping-advices/${this.form.id}/calc?addFreightInvNo=true`
          )
        })
        .then(() => {
          this.$message('', '海上運賃計算成功')
          this.load()
        })
        .catch((err) => this.$catch(err))
    },
    saveAdjustValue() {
      var value = this.form.charges
        .filter((i) => i.isFreight || i.isDestinationCharge)
        .filter((i) => i.adjustable == true)
        .filter(
          (i) =>
            (i.originalSubTotal && i.originalSubTotal > 0) ||
            (i.paymentOriginalSubTotal && i.paymentOriginalSubTotal > 0)
        )
        .map((c) => {
          return {
            // id: c.id,
            shipmentId: c.shipmentId,
            chargeItemId: c.chargeItemId,
            containerTypeCode: c.containerTypeCode,
            subTotalAdjust: c.subTotalAdjust,
            paymentSubTotalAdjust: c.paymentSubTotalAdjust,
            recordUnitCode: c.recordUnitCode,
            comment: c.comment,
          }
        })
      return this.$http.put(
        '/delivery-orders/adjust-value?token=subTotalAdjust',
        value
      )
    },

    chargeGeneration2(isInternationalFreightZero) {
      this.$http
        .put(`/shipping-advices/${this.form.id}?view=B1001`, this.form)
        .then(() => {
          return this.$http.put(
            `/shipping-advices/${this.form.id}/calc?addFreightInvNo=true&isInternationalFreightZero=${isInternationalFreightZero}`
          )
        })
        .then(() => this.saveAdjustValue())
        .then(() => this.calcInsurance())
        .then(() => {
          return this.$http.put(
            `/shipping-advices/${this.form.id}/charges-share`
          )
        })
        .then(() => this.putProviders())
        .then(() => {
          this.$message('', '海上運賃計算成功')
          this.load()
        })
        .catch((err) => this.$catch(err))
    },

    putProviders() {
      const currentShipmentId = this.form.id
      return this.$http.put(`/overseas-providers?shipmentId=${this.form.id}`, [
        ...this.$refs.requestArea
          .getCharges()
          .filter((i) => i.isFreight)
          .map((i) => {
            return {
              shipmentId: i.shipmentId,
              chargeItemId: i.chargeItemId,
              providerId: i.providerId,
              containerTypeCode: i.containerTypeCode,
            }
          }),
        ...this.$refs.handArea.items.map((i) => {
          return {
            shipmentId: currentShipmentId,
            chargeItemId: i.id,
            providerId: i.providerId,
          }
        }),
      ])
    },

    calcInsurance() {
      return this.$http.put(`/shipping-advices/${this.form.id}/calc-insurance`)
    },
    freightConfirm() {
      this.$confirm({ content: 'フレイトを確認してよろしいでしょうか?' }).then(
        () => {
          this.$http
            .put(`/shipping-advices/${this.form.id}?view=B1001`, this.form)
            .then(() => this.saveAdjustValue())
            .then(() => this.calcInsurance())
            .then(() => this.putProviders())
            .then(() =>
              this.$http.get(`/delivery-orders/${this.form.id}/check-currency`)
            )
            .then(() => {
              return this.$http.put(
                `/shipping-advices/${this.form.id}/freight-confirm`
              )
            })
            .then(() => {
              this.$message('', 'フレイト確認济')
              this.load()
            })
            .catch((err) => this.$catch(err))
        }
      )
    },
    freightConfirmCancel() {
      this.$confirm({
        content: 'フレイト確認を取り消してよろしいでしょうか',
      }).then(() => {
        this.$http
          .put(`/shipping-advices/${this.form.id}/freight-confirm-cancel`)
          .then(() => {
            this.$message('', 'フレイト取消济')
            this.load()
          })
          .catch((err) => this.$catch(err))
      })
    },
  },
  mounted() {
    this.load()
  },
}
</script>